<quant-modal [responsiveStyles]="true">
  <div class="modal" *ngIf="controlService && deviceSettingsService && playerService">

    <!-- No internet -->
    <ng-container *ngIf="!callStore.getIsLoadingNoResponse() && !isInternetConnected">
      <div class="header">
        <div class="title">{{'call.NO_INTERNET' | transloco}}</div>
        <div class="message">
          {{'call.TRY_AGAIN' | transloco}}
        </div>
      </div>
      <div class="actions">
        <div class="action" *ngIf="callStore.getIsAudioDeviceSelected()">
          <quant-button [label]="'call.TRY_AGAIN_LABEL' | transloco" [disabled]="disabledButtons" hierarchy="primary" size="lg"
            (click)="tryAgain()"></quant-button>
        </div>
      </div>
    </ng-container>

    <!-- Mic is muted -->
    <ng-container
      *ngIf="!callStore.getIsLoadingNoResponse() && isInternetConnected && !controlService.isMicOnBeforePause && !playerService.converseStatus">
      <div class="header">
        <div class="icon"> <img src="assets/icons/alert-triangle-yellow.svg" /> </div>
        <div class="title">{{'call.MIC_MUTED' | transloco}}</div>
        <div class="message">
          {{'call.MIC_MUTED_DESCRIPTION' | transloco}}
        </div>
      </div>
      <div class="actions">
        <div class="action">
          <quant-button [label]="'call.RETURN_TO_CALL' | transloco" [disabled]="disabledButtons" hierarchy="primary" size="lg"
            (click)="closeModal()"></quant-button>
        </div>
      </div>
    </ng-container>

    <!-- Mic is disconnected -->
    <ng-container
      *ngIf="!callStore.getIsLoadingNoResponse() && isInternetConnected && controlService.isMicOnBeforePause && !callStore.getIsAudioDeviceSelected()">
      <div class="header">
        <div class="icon"> <img src="assets/icons/alert-triangle-yellow.svg" /> </div>
        <div class="title">{{'call.NO_RESPONSE' | transloco}}</div>
        <div class="message">
          {{'call.MIC_NOT_CONNECTED' | transloco}}
        </div>
      </div>
      <div class="actions">
        <div class="action">
          <quant-button [label]="'call.CHECK_SETTINGS' | transloco" [disabled]="disabledButtons" hierarchy="primary"
            size="lg" (click)="checkSettings()"></quant-button>
        </div>
      </div>
    </ng-container>

    <!-- Something went wrong -->
    <ng-container *ngIf="!callStore.getIsLoadingNoResponse() && isInternetConnected && controlService.isMicOnBeforePause && callStore.getIsAudioDeviceSelected() && !callStore.getIsErrorOnAudioValidation()
        && !playerService.converseStatus">
      <div class="header">
        <div class="icon"> <img src="assets/icons/alert-triangle-yellow.svg" /> </div>
        <div class="title">{{'call.NO_RESPONSE' | transloco}}</div>
        <div class="message">
          {{'call.AUDIO_ISSUE' | transloco}}
        </div>
      </div>
      <div class="actions">
        <div class="action">
          <quant-button [label]="'call.CHECK_SETTINGS' | transloco" [disabled]="disabledButtons"
            hierarchy="primary-dark" size="lg" (click)="checkSettings()"></quant-button>
        </div>
        <div class="action" *ngIf="callStore.getIsAudioDeviceSelected()">
          <quant-button [label]="'call.TRY_AGAIN_LABEL' | transloco" [disabled]="disabledButtons" hierarchy="primary"
            size="lg" (click)="tryAgain()"></quant-button>
        </div>
      </div>
    </ng-container>

    <!-- Is loading -->
    <ng-container *ngIf="callStore.getIsLoadingNoResponse()">
      <div class="header">
        <div class="icon" *ngIf="!playerService.converseStatus"> <img src="assets/icons/alert-triangle-yellow.svg" />
        </div>
        <div class="title">{{'call.LOADING_ALT' | transloco}}</div>
        <div class="message">
            {{ waitingForResponse ? ('call.REPEAT_RESPONSE' | transloco) : '' }}
        </div>
      </div>
      <div class="actions">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </ng-container>

    <!-- Avatar needs time to think  -->
    <ng-container
      *ngIf="playerService.converseStatus === 'thinking' && isInternetConnected && !callStore.getIsLoadingNoResponse()">
      <div class="header">
        <div class="title">{{'call.LOADING_ALT' | transloco}}</div>
        <div class="message">
          {{ playerService.avatarName }} {{'call.NEEDS_MORE_TIME_QUESTION' | transloco}}
        </div>
      </div>
      <div class="actions">
        <div class="action">
          <quant-button [label]="'call.NO' | transloco" [disabled]="disabledButtons" hierarchy="primary-dark" size="md"
            (click)="goAssignments()"></quant-button>
        </div>
        <div class="action" *ngIf="callStore.getIsAudioDeviceSelected()">
          <quant-button [label]="'call.YES' | transloco" [disabled]="disabledButtons" hierarchy="primary" size="md"
            (click)="waitForResponse()"></quant-button>
        </div>
      </div>
    </ng-container>

    <!-- Avatar not available  -->
    <ng-container
      *ngIf="playerService.converseStatus === 'unavailable' && isInternetConnected && !callStore.getIsLoadingNoResponse()">
      <div class="header">
        <div class="title">{{'call.LOADING_ALT' | transloco}}</div>
        <div class="message">
          {{ playerService.avatarName }} {{'call.NEEDS_MORE_TIME' | transloco}}
          {{'call.WAIT_OR_END_CALL' | transloco}}
          <span class="link" (click)="goAssignments()"> {{'call.RETURN_TO_ASSIGNMENTS' | transloco}}</span>
        </div>
      </div>
      <div class="actions"></div>
    </ng-container>

    <!-- Avatar ready -->
    <ng-container
      *ngIf="playerService.converseStatus === 'ready' && isInternetConnected && !callStore.getIsLoadingNoResponse()">
      <div class="header">
        <div class="title">{{'call.READY' | transloco}}</div>
        <div class="message">
          {{ playerService.avatarName }} {{'call.IS_READY' | transloco}}
        </div>
      </div>
      <div class="actions actions-right">
        <quant-button [label]="'call.RETURN_TO_CALL' | transloco" [disabled]="disabledButtons" hierarchy="primary" size="md"
          (click)="continueAvatarReady()"></quant-button>
      </div>
    </ng-container>
  </div>
</quant-modal>
